import {getWithAuth, putWithAuth} from '@/api'
import {
    BankDetailReason,
    ChangeBankAccountDetailsRequest
} from '@/stores/change-bank-account-details/models'

export const changeBankAccountDetails = (data: ChangeBankAccountDetailsRequest) =>
    putWithAuth<{}>('/oppapi/v1/merchant-info/bank-details', data)

export const getBankDetailReasons = () =>
    getWithAuth<BankDetailReason[]>('/oppapi/v1/merchant-info/bank-details/reasons')
